import { aquaAxiosWithCreds } from 'lib/utilityFunctions';
import { logRumError } from 'lib/DDRum';
import { USAGE_TAGS } from 'lib/constants';

import { USAGE_URL } from './endpoints';

/**
 * Fetches usage data for a student for a given product, starting from the provided date.
 * Aggregates by day using the device's local timezone.
 * Logs a RUM error and rethrows on failure.
 * @param {object} params
 * @param {string} params.studentAmpId - The student's AMP ID
 * @param {string} params.product - The product key (e.g. 'reading', 'lectura')
 * @param {string} params.startDate - The start date in "YYYY-MM-DD" format
 * @returns {Promise<object>} A map of date strings to usage values in seconds, or {} if no data
 */
// eslint-disable-next-line import/prefer-default-export
export const fetchUsage = async ({ studentAmpId, product, startDate }) => {
  try {
    const { data } = await aquaAxiosWithCreds(USAGE_URL, {
      method: 'POST',
      data: {
        amp_ids: [studentAmpId],
        include_tags: [`${USAGE_TAGS.PROGRAM.prefix}: ${USAGE_TAGS.PROGRAM.value[product]}`],
        start_date: startDate,
        query_type: 'subset',
        aggregate_unit: 'day',
        timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    });
    return data?.usage?.[studentAmpId] ?? {};
  } catch (error) {
    logRumError('RTU: usage API request failed', {
      product,
      startDate,
      status: error?.response?.status,
      error: error?.message,
    });
    throw error;
  }
};
